import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Divider,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Backdrop,
  CircularProgress,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  TableFooter,
} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Layout from "../../../layout/Layout";
import "../../../assets/css/dashboard.css";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import UserAvatar from "../../../components/UserAvatar";
import DashboardCard from "../../../components/DashboardCard";
import { Box } from "@mui/system";
import { agentDashboardAPI, config, userData, statusAPI, ticketAPI } from "../../../config";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const calculateTotals = (data) => {
  return data.reduce(
    (acc, curr) => {
      acc.Open += curr.Open_Count || 0;
      acc.PendingAdmin += curr.Pending_Admin_Count || 0;
      acc.PendingUser += curr.Pending_User_Count || 0;
      acc.PendingVendor += curr.Pending_Vendor_Count || 0;
      acc.OnHold += curr.OnHold_Count || 0;
      acc.Closed += curr.Closed_Count || 0;
      acc.Total += (curr.Open_Count || 0) + (curr.Pending_Admin_Count || 0) + (curr.Pending_User_Count || 0) + (curr.Pending_Vendor_Count || 0) + (curr.OnHold_Count || 0) + (curr.Closed_Count || 0);
      return acc;
    },
    { Open: 0, PendingAdmin: 0, PendingUser: 0, PendingVendor: 0, OnHold: 0, Closed: 0, Total: 0 }
  );
};

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const typesData = row.Types_data ? JSON.parse(row.Types_data) : [];
  const nestedTotals = calculateTotals(typesData);

  return (
    <React.Fragment>
      <TableRow
        sx={{ 
          '&:hover': { backgroundColor: '#f3e5f5' },
          backgroundColor: open ? '#f3e5f5' : 'inherit'
        }}
      >
        <TableCell sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{ mr: 1 }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {row.agent_name}{row.agent_id !== -1 && row.agent_status === 0 ? <span style={{ color: 'red' }}> (Inactive)</span> : ""}
        </TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.Open_Count}</TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.Pending_Admin_Count}</TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.Pending_User_Count}</TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.Pending_Vendor_Count}</TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.OnHold_Count}</TableCell>
        <TableCell align="center" sx={{ borderRight: '1px solid #c8a0d8', borderBottom: '1px solid #c8a0d8' }}>{row.Closed_Count}</TableCell>
        <TableCell align="center" sx={{ fontWeight: 'bold', borderBottom: '1px solid #c8a0d8' }}>
          {(row.Open_Count || 0) + (row.Pending_Admin_Count || 0) + (row.Pending_User_Count || 0) + (row.Pending_Vendor_Count || 0) + (row.OnHold_Count || 0) + (row.Closed_Count || 0)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: '10px' }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="types-breakdown">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#9c27b0' }}>
                    <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Type</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Open</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Pending by Admin</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Pending by User</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Pending by Vendor</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>On Hold</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Closed</TableCell>
                    <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {typesData.length > 0 ? (
                    typesData.map((typeRow, idx) => (
                      <TableRow key={idx} sx={{ '&:hover': { backgroundColor: '#fafafa' } }}>
                        <TableCell component="th" scope="row">
                          {typeRow.type_name}
                        </TableCell>
                        <TableCell align="center">{typeRow.Open_Count}</TableCell>
                        <TableCell align="center">{typeRow.Pending_Admin_Count}</TableCell>
                        <TableCell align="center">{typeRow.Pending_User_Count}</TableCell>
                        <TableCell align="center">{typeRow.Pending_Vendor_Count}</TableCell>
                        <TableCell align="center">{typeRow.OnHold_Count}</TableCell>
                        <TableCell align="center">{typeRow.Closed_Count}</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {(typeRow.Open_Count || 0) + (typeRow.Pending_Admin_Count || 0) + (typeRow.Pending_User_Count || 0) + (typeRow.Pending_Vendor_Count || 0) + (typeRow.OnHold_Count || 0) + (typeRow.Closed_Count || 0)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">No detailed data available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
                {typesData.length > 0 && (
                  <TableFooter sx={{ backgroundColor: '#f3e5f5' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.Open}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.PendingAdmin}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.PendingUser}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.PendingVendor}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.OnHold}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.Closed}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 'bold' }}>{nestedTotals.Total}</TableCell>
                    </TableRow>
                  </TableFooter>
                )}
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function AgentDashboard() {
  const [dashboardCardList, setDashboardCardList] = useState([]);
  const [todoList, setTodoList] = useState([]);
  const [Positive, setPositive] = useState(0);
  const [Negative, setNegative] = useState(0);
  const [Neutral, setNeutral] = useState(0);
  const [totalReview, setTotalReview] = useState(0);
  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(0);
  const [agentList, setAgentList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(userData.role === "agent" ? userData.id : 0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [agentPerformanceData, setAgentPerformanceData] = useState([]);
  const mainTotals = calculateTotals(agentPerformanceData);

  const fetchDashboardCards = (deptId = 0, agentId = 0, fDate = fromDate, tDate = toDate) => {
    const payload = {
      intUserID: userData.id,
      intSPType: 26,
    };
    if (deptId > 0) payload.intDepartment = deptId;
    if (agentId > 0) payload.intAgentID = agentId;
    if (fDate !== "") payload.txtFromDate = fDate;
    if (tDate !== "") payload.txtToDate = tDate;
    const data = JSON.stringify(payload);
    config.method = "PATCH";
    config.data = data;
    config.url = agentDashboardAPI;
    return axios(config)
      .then(function (response) {
        setDashboardCardList(response.data["data"] || []);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const fetchTodoList = (deptId = 0, agentId = 0, fDate = fromDate, tDate = toDate) => {
    const payload = {
      intUserID: userData.id,
      intSPType: 9,
    };
    if (deptId > 0) payload.intDepartment = deptId;
    if (agentId > 0) payload.intAgentID = agentId;
    if (fDate !== "") payload.txtFromDate = fDate;
    if (tDate !== "") payload.txtToDate = tDate;
    const data = JSON.stringify(payload);
    config.method = "PATCH";
    config.data = data;
    config.url = agentDashboardAPI;
    return axios(config)
      .then(function (response) {
        setTodoList(response.data["data"] || []);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const fetchReviewSummary = (deptId = 0, agentId = 0, fDate = fromDate, tDate = toDate) => {
    const payload = {
      intUserID: userData.id,
      intSPType: 8,
    };
    if (deptId > 0) payload.intDepartment = deptId;
    if (agentId > 0) payload.intAgentID = agentId;
    if (fDate !== "") payload.txtFromDate = fDate;
    if (tDate !== "") payload.txtToDate = tDate;
    const data = JSON.stringify(payload);
    config.method = "PATCH";
    config.data = data;
    config.url = agentDashboardAPI;
    return axios(config)
      .then(function (response) {
        const tempData = response.data["data"] || [];
        let total = 0;
        let pos = 0, neu = 0, neg = 0;
        for (let i = 0; i < tempData.length; i++) {
          if (tempData[i].review === 5) {
            pos = tempData[i].count;
            total += tempData[i].count;
          }
          if (tempData[i].review === 3) {
            neu = tempData[i].count;
            total += tempData[i].count;
          }
          if (tempData[i].review === 1) {
            neg = tempData[i].count;
            total += tempData[i].count;
          }
        }
        setPositive(pos);
        setNeutral(neu);
        setNegative(neg);
        setTotalReview(total);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };
 
  const fetchAgentPerformance = (deptId = 0, fDate = fromDate, tDate = toDate) => {
    const payload = {
      intUserID: userData.id,
      intSPType: 32,
    };
    if (deptId > 0) payload.intDepartment = deptId;
    if (fDate !== "") payload.txtFromDate = fDate;
    if (tDate !== "") payload.txtToDate = tDate;
    const data = JSON.stringify(payload);
    config.method = "PATCH";
    config.data = data;
    config.url = agentDashboardAPI;
    return axios(config)
      .then(function (response) {
        const data = response.data["data"] || [];
        // Sort to put Unassigned at the end
        const sortedData = [...data].sort((a, b) => {
          if (a.agent_name === "Unassigned") return 1;
          if (b.agent_name === "Unassigned") return -1;
          return 0;
        });
        setAgentPerformanceData(sortedData);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const fetchAllDashboardData = async (deptId = 0, agentId = 0) => {
    setLoading(true);
    try {
      await Promise.all([
        fetchDashboardCards(deptId, agentId),
        fetchTodoList(deptId, agentId),
        fetchReviewSummary(deptId, agentId),
        fetchAgentPerformance(deptId)
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      // Fetch department list
      const deptData = JSON.stringify({ limit: 0, offset: 0, parent_id: "35" });
      config.method = "PATCH";
      config.data = deptData;
      config.url = statusAPI;
      axios(config)
        .then(function (response) {
          setDepartmentList(response.data["data"] || []);
        })
        .catch(function (error) {
          console.log(error);
        });

      // Fetch agent list
      const agentData = JSON.stringify({ intSPType: 16 });
      config.method = "PATCH";
      config.data = agentData;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setAgentList(response.data["data"] || []);
        })
        .catch(function (error) {
          console.log(error);
        });

      // Fetch all dashboard data (initial load)
      fetchAllDashboardData(0, userData.role === "agent" ? userData.id : 0);

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const [checked, setChecked] = React.useState([0]);

  const handleToggle1 = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <Layout>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <div className={`spinner-white-bg`}>
          <div className="spinner"></div>
        </div>
      </Backdrop>
      
      <Box sx={{ px: 3 }}>
        {/* Row 1: Dates and Buttons */}
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 3, 
          mb: 2, 
          alignItems: "center" 
        }}>
          <Box sx={{ minWidth: 250 }}>
            <DatePicker
              selected={fromDate ? new Date(fromDate) : null}
              onChange={(date) => setFromDate(date ? moment(date).format("YYYY-MM-DD") : "")}
              placeholderText="From Date"
              dateFormat="yyyy-MM-dd"
              className="custom-date-picker"
            />
          </Box>
          <Box sx={{ minWidth: 250 }}>
            <DatePicker
              selected={toDate ? new Date(toDate) : null}
              onChange={(date) => setToDate(date ? moment(date).format("YYYY-MM-DD") : "")}
              placeholderText="To Date"
              dateFormat="yyyy-MM-dd"
              className="custom-date-picker"
            />
          </Box>
          <Button
            variant="contained"
            size="medium"
            onClick={() => {
              if (fromDate && toDate) {
                fetchAllDashboardData(selectedDepartment, selectedAgent);
              } else {
                alert("Please select both From and To dates");
              }
            }}
            className="btn-primary"
            sx={{ height: 45, px: 4, minWidth: 150 }}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            size="medium"
            onClick={() => {
              setFromDate("");
              setToDate("");
              fetchDashboardCards(selectedDepartment, selectedAgent, "", "");
              fetchTodoList(selectedDepartment, selectedAgent, "", "");
              fetchReviewSummary(selectedDepartment, selectedAgent, "", "");
              fetchAgentPerformance(selectedDepartment, "", "");
            }}
            sx={{ height: 45, px: 4, minWidth: 150 }}
          >
            Clear
          </Button>
        </Box>
  
        {/* Row 2: Dropdowns */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: "flex-end", 
          flexWrap: 'wrap', 
          gap: 3, 
          mb: 3, 
          alignItems: "center" 
        }}>
          <Autocomplete
            size="small"
            sx={{ minWidth: 300 }}
            options={[{ id: 0, name: "All Departments" }, ...departmentList]}
            getOptionLabel={(option) => option.name || ""}
            value={departmentList.find(d => d.id === selectedDepartment) || { id: 0, name: "All Departments" }}
            onChange={(event, newValue) => {
              const val = newValue ? newValue.id : 0;
              setSelectedDepartment(val);
              fetchAllDashboardData(val, selectedAgent);
            }}
            renderInput={(params) => <TextField {...params} label="Department" variant="outlined" />}
          />
  
          {userData.role !== "agent" && (
            <Autocomplete
              size="small"
              sx={{ minWidth: 300 }}
              options={[{ id: 0, name: "All IT Admins" }, ...agentList]}
              getOptionLabel={(option) => option.name || ""}
              value={agentList.find(a => a.id === selectedAgent) || { id: 0, name: "All IT Admins" }}
              onChange={(event, newValue) => {
                const val = newValue ? newValue.id : 0;
                setSelectedAgent(val);
                fetchAllDashboardData(selectedDepartment, val);
              }}
              renderInput={(params) => <TextField {...params} label="IT Admin" variant="outlined" />}
            />
          )}
        </Box>
  
        {/* Row 3: Cards */}
        <Grid container spacing={4}>
          {dashboardCardList.map((row, id) => (
            <Grid item xs={12} sm={6} md={4} lg={2} key={id}>
              <DashboardCard
                title={row.title}
                count={row.count}
                id={row.id}
                deptId={selectedDepartment}
                agentId={selectedAgent}
                fromDate={fromDate}
                toDate={toDate}
              />
            </Grid>
          ))}
        </Grid>
  
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={4}>
            {userData.role !== "agent" && (
              <Grid item xs={12} lg={7} md={7}>
                <Card className={`dashboard-1-card`} sx={{ height: '100%', minHeight: 'fit-content' }}>
                  <Box sx={{ mb: 2 }}>
                    <Typography className={`text--dark text--medium`} variant="h6">
                      IT Admin Performance
                    </Typography>
                  </Box>
                  <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'auto' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="agent performance table">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#9c27b0' }}>
                          <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>IT Admin Name</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>Open</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>Pending by IT Admin</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>Pending by User</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>Pending by Vendor</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>On Hold</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff', borderRight: '1px solid rgba(255,255,255,0.2)' }}>Closed</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold', color: '#fff' }}>Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {agentPerformanceData.length > 0 ? (
                        agentPerformanceData.map((row) => (
                          <Row key={row.agent_id} row={row} />
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} align="center" sx={{ py: 3 }}>No data available</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    {agentPerformanceData.length > 0 && (
                      <TableFooter sx={{ backgroundColor: '#f3e5f5' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.Open}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.PendingAdmin}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.PendingUser}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.PendingVendor}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.OnHold}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.Closed}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 'bold' }}>{mainTotals.Total}</TableCell>
                        </TableRow>
                      </TableFooter>
                    )}
                    </Table>
                  </TableContainer>
                </Card>
              </Grid>
            )}
  
            <Grid item xs={12} lg={userData.role !== "agent" ? 5 : 12} md={userData.role !== "agent" ? 5 : 12}>
              <Card className={`dashboard-1-card`} sx={{ height: '100%' }}>
                <Box sx={{ mb: 2 }}>
                  <Typography className={`text--dark text--medium`}>
                    To-do
                  </Typography>
                </Box>
  
                {todoList.map((row, index) => (
                  <Grid display={`flex`} key={index} className={`dashboard-todo`} sx={{ mb: 1 }}>
                    <Typography sx={{ fontWeight: 600, minWidth: '100px' }}>Ticket ID: {row.id}</Typography>
                    <Typography sx={{ ml: 2 }}>{row.description}</Typography>
                  </Grid>
                ))}
  
                <Box textAlign={`right`} className={`dashboard-a-tag`} sx={{ mt: 'auto', pt: 2 }}>
                  <a href="/agent/todo">More</a>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Layout>
  );
}

export default AgentDashboard;
